import HomePage from './views/home/HomePage';

const createRouteMetaInfo = (seoConfig) => ({ seo: seoConfig });

// Componente "passthrough" para la ruta padre con prefijo de idioma.
const LangShell = { render: (h) => h('router-view') };

// Rutas hijas (paths relativos, sin barra inicial). Se montan bajo el prefijo
// opcional de idioma `/:lang` para tener una URL por idioma (SEO).
const childRoutes = [
  { path: '', component: HomePage, name: 'Home' },
  {
    path: 'login',
    component: () => import('./views/profile/login/LoginPage.vue'),
    name: 'Login',
    meta: createRouteMetaInfo({ title: 'Sign in — Nukli' }),
  },
  {
    path: 'reset-password',
    component: () => import('./views/profile/reset/ResetPasswordPage.vue'),
    name: 'ResetPassword',
    meta: createRouteMetaInfo({ title: 'Reset password — Nukli' }),
  },
  {
    path: 'download',
    component: () => import('./views/download/DownloadPage.vue'),
    name: 'Download',
    meta: createRouteMetaInfo({ title: 'Download — Nukli' }),
  },
  {
    // Enlace de invitación del programa de referidos: /r/<código>.
    path: 'r/:code',
    component: () => import('./views/referral/ReferralLanding.vue'),
    name: 'Referral',
    meta: createRouteMetaInfo({ title: "You're invited — Nukli" }),
  },
  {
    path: 'account',
    component: () => import('./views/account/AccountDashboard.vue'),
    name: 'Account',
    meta: { ...createRouteMetaInfo({ title: 'Account — Nukli' }), requiresAuth: true },
  },
  {
    path: 'auth/callback',
    component: () => import('./views/auth/OAuthCallback.vue'),
    name: 'OAuthCallback',
    meta: createRouteMetaInfo({ title: 'Signing in — Nukli' }),
  },
  { path: 'premium/success', component: () => import('./views/premium/SuccessfulSubscription.vue'), name: 'SuccessfulSubscription' },
  { path: 'premium/cancel', component: () => import('./views/premium/CancelledSubscription.vue'), name: 'CancelledSubscription' },
  { path: 'contact', name: 'Contact', component: () => import('./views/contact/Contact.vue') },
  {
    // Seguridad y privacidad: la página que se manda al IT de un cliente
    // potencial (qué IA se usa, dónde viven los datos, proveedores, DPA).
    path: 'security',
    name: 'Security',
    component: () => import('./views/security/SecurityPage.vue'),
  },
  {
    // Guías de uso: el "cómo se hace" que la app enlaza cuando el asistente
    // recomienda una. Viven aparte del blog porque el lector es distinto:
    // aquí ya tiene Nukli abierta y quiere saber dónde pulsar.
    path: 'guides',
    name: 'Guides',
    component: () => import('./views/guides/GuidesIndex.vue'),
    meta: createRouteMetaInfo({ title: 'Guides — Nukli' }),
  },
  { path: 'guides/:slug', name: 'Guide', component: () => import('./views/guides/GuidePage.vue') },
  { path: 'blog', name: 'Blog', component: () => import('./views/blog/BlogIndex.vue'), meta: createRouteMetaInfo({ title: 'Blog — Nukli' }) },
  { path: 'blog/:slug', name: 'BlogArticle', component: () => import('./views/blog/BlogArticle.vue') },
  {
    path: 'admin',
    name: 'Admin',
    component: () => import('./views/admin/AdminStats.vue'),
    meta: { ...createRouteMetaInfo({ title: 'Admin — Nukli' }), requiresAuth: true },
  },
  {
    path: 'admin/blog',
    name: 'BlogModeration',
    component: () => import('./views/admin/BlogModeration.vue'),
    meta: { ...createRouteMetaInfo({ title: 'Blog moderation — Nukli' }), requiresAuth: true },
  },
  { path: 'politics/cookies', component: () => import('./views/politiques/Cookies.vue') },
  { path: 'politics/privaci', component: () => import('./views/politiques/Privicitat.vue') },
  { path: 'politics/legal', component: () => import('./views/politiques/Legal.vue') },
  { path: 'politics/terms', component: () => import('./views/politiques/CondicionesGenerales.vue') },
  { path: '404', component: () => import('./views/politiques/NotFoundComponent.vue'), name: 'NotFound' },
];

const routes = [
  {
    // El prefijo de idioma solo captura 2 letras (en, es, ca, fr…). El idioma
    // por defecto (inglés) no lleva prefijo: "/" en lugar de "/en".
    path: '/:lang([a-z]{2})?',
    component: LangShell,
    children: childRoutes,
  },
  { path: '*', redirect: '/404' },
];

export default routes;
